import { render, staticRenderFns } from "./RetrievePassword.vue?vue&type=template&id=604c319b&scoped=true&"
import script from "./RetrievePassword.vue?vue&type=script&lang=js&"
export * from "./RetrievePassword.vue?vue&type=script&lang=js&"
import style0 from "./RetrievePassword.vue?vue&type=style&index=0&id=604c319b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604c319b",
  null
  
)

export default component.exports